export default __webpack_public_path__ + "assets/ico_step_10-9f3c7d4e.svg";